import React from 'react';
import withStyles from "../wrappers/withStyles";

function Statements({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g fill={color} fillRule="nonzero" stroke="none" strokeWidth="1">
        <path
          d="M60.832 0H16.718a5.703 5.703 0 00-5.696 5.696v3.637H5.837A5.703 5.703 0 00.14 15.03v59.14a5.703 5.703 0 005.696 5.696h44.115a5.703 5.703 0 005.696-5.696V70.53h5.184a5.703 5.703 0 005.696-5.696V5.695A5.703 5.703 0 0060.832 0zm-9.74 74.169c0 .627-.513 1.139-1.14 1.139H5.837c-.627 0-1.14-.512-1.14-1.14V15.03c0-.628.513-1.139 1.14-1.139h5.185v50.945a5.703 5.703 0 005.696 5.696h34.374v3.638zm10.88-9.334c0 .628-.512 1.14-1.14 1.14H16.718a1.14 1.14 0 01-1.14-1.14V5.695c0-.627.511-1.138 1.14-1.138h44.114c.628 0 1.14.511 1.14 1.139v59.14z"
          transform="translate(10 10) translate(6.598)"
        />
        <path
          d="M55.482 14.15H22.068a2.279 2.279 0 000 4.557h33.414a2.278 2.278 0 100-4.557zM55.482 24.994H22.068a2.279 2.279 0 000 4.557h33.414a2.278 2.278 0 100-4.557zM55.482 35.838H22.068a2.28 2.28 0 000 4.557h33.414a2.278 2.278 0 100-4.557zM55.482 46.683H22.068a2.28 2.28 0 000 4.556h33.414a2.277 2.277 0 100-4.556z"
          transform="translate(10 10) translate(6.598)"
        />
      </g>
    </svg>
  );
}

Statements.defaultProps = {
  color: 'white',
};

export default withStyles(Statements);
